import { render, staticRenderFns } from "./CodeBuildingLayout.vue?vue&type=template&id=05d355e2&"
import script from "./CodeBuildingLayout.vue?vue&type=script&lang=js&"
export * from "./CodeBuildingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports